import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChartDataset, ChartOptions, ChartType } from 'chart.js';
import { Subscription } from 'rxjs';
import { LoginService } from '../login.service';
import { StatsService } from '../stats.service';
import { PathologyService } from '../pathology.service';
import * as XLSX from "xlsx";

@Component({
    selector: 'app-stats',
    templateUrl: './stats.component.html',
    styleUrls: ['./stats.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class StatsComponent implements OnInit, OnDestroy {
  selecteduser;
  data;
  public ChartOptions: any = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Exams'
      }
    },
    scales:{
      y: {
        display: false,
        stacked: false,
        ticks: {
            min: 0, // minimum value
        }
    }
    }
  };
  public ChartLabels: string[] = [];
  public ChartDataMulti: any[][] = [];
  public dougnutData=[]
  public ChartDataSingle: any = [];
  public barChartData: ChartDataset<'bar'>[] = [{data:[], label:'Exams'}];

  
  public ChartType: ChartType = 'pie';
  public ChartLegend = true;
  public ChartPlugins = [];
  public ChartBackgroundColors = [
    'lightgreen', 'lightblue', 'lightyellow', 'indianred', 'mediumpurple', 'darkgreen', 'deepskyblue', 'lightpink', 'orangered', 'purple','bisque','yellow'
  ];

  get pieChartDatasets(): ChartDataset<'pie'>[] {
    return [{ data: this.ChartDataSingle, backgroundColor: this.ChartBackgroundColors }];
  }

  chartType='pie';
  dataType='exams';
  hmoType='';
  type = 'date';
  showprint;
  date='1';
  name;
  showprintopts;
  ExamType;
  startdate;
  enddate;
  dateType ='months';
  filterdUsers = [];
  typeOfPrint;
  Direction;
  code;
  examsArray = [];
  hmoNotAssign =[];
  sub = new Subscription()
  loaded = false;
  searchByType = 'TerminationRemarks';
  startdateb: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  enddateb: Date = new Date();
  HMO = '';

  constructor(private route: ActivatedRoute,private http:HttpClient, public sts:StatsService, public ls:LoginService, private pathologyService:PathologyService, private datePipe: DatePipe) {
  }


  ngOnInit() {
    this.ls.loginMissing();
    this.examsArray = this.sts.GYN;
    if(this.ls.isUSG){
      this.examsArray = this.sts.USG;
    }
    if(this.ls.isCardio)
      this.examsArray = this.sts.CARDIO
    this.onSearch();
    this.sts.statsLoaded$.subscribe(() => {
      if(this.ls.isUSG)
        this.examsArray = this.sts.examsArray;
      this.filterByName(null);
      this.setData();
    })

  }

  onSearch(){
    this.loaded = false;
    var params;
    switch (this.type) {
      case 'date':
        if(this.dateType == 'months'){
          params ={
            type: this.type,
            date: this.date.toString(),
            searchByType:this.searchByType

          }
        }else{
          var fd;
          var td;
          try{
            fd = this.enddate._i.year+'-'+(this.enddate._i.month + 1)+'-'+this.enddate._i.date + ' 23:59:59' ;
            td = this.startdate._i.year+'-'+(this.startdate._i.month + 1)+'-'+this.startdate._i.date + ' 00:00:00';
          }catch{
            fd =  this.enddate.toISOString().slice(0, 19).split('T')[0] + ' 23:59:59';
            td = this.startdate.toISOString().slice(0, 19).split('T')[0] + ' 00:00:00';
          }
          params ={
            type: this.type,
            start: td,
            end: fd,
            searchByType:this.searchByType

          }
        }
        this.selecteduser =null
        this.sts.search(params, null)
        break;
      case 'name':
          params ={
            type: this.type,
            searchByType:this.searchByType

          }
          break;
        case 'exam':
          params ={
            type: this.type,
            ExamType: this.ExamType,
            searchByType:this.searchByType

          }
          break;
      
      default:
        break;
    }
  }

  onSetType(){
    switch (this.type) {
      case 'date':
          this.name= null;
          this.ExamType=null;
          this.dateType='months';
          this.date = '1'
          this.onSearch();
        break;
      case 'name':
        this.date=null;
        this.ExamType=null;
        this.dateType=null;
        this.onSearch();
        break;
      case 'exam':
        this.date=null;
        this.dateType=null;
        this.name=null;
        this.onSearch();
        break;
      default:
        break;
    }
  }

  filterByName(str){
    if(str){
      this.filterdUsers =  this.sts.usersStats.filter((i) => i.user.UserName.includes(str))
    }else{
      this.filterdUsers = this.sts.usersStats;
    }
  }

  getDb(exam){
    if(!exam)
      return;
    if(exam == '1st')
      return 'first'
    if(exam == '2nd/3rd')
      return 'second'
    return exam.replace(/ /g, '').replace(/-/g, '')
  }



  setData(){
    if( !this.ls.isAdmin  && !this.selecteduser){
      var temp = this.sts.usersStats.filter((i) => i.user.UserName.includes(this.ls.loginname))
      this.sts.statsForm.patchValue(temp[0].exams)
      this.sts.totalLength = temp[0].exams.length
    }
    this.ChartLabels = [];
    this.ChartDataSingle = [];
    this.ChartDataMulti = [];
    var tempTitle = this.selecteduser ? this.selecteduser.user.UserName+' Exams' : 'All Exams';
    this.barChartData = [{data:[], label:tempTitle, backgroundColor: this.ChartBackgroundColors}];
    // this.barChartDataSingle[0]['data']=[]
    this.dataType = 'exams';
    this.dougnutData = [];
    var tempData =[];

    if(this.selecteduser){
      var i =0 
      for( var ob in this.selecteduser.exams){
        if(this.ls.isUSG && ob == 'Clinics' && this.sts.clinicGroups.length > 0){
          for(let group of this.sts.clinicGroups)
            tempData[i++]=group
        }
        else
          tempData[i++]=ob
      }
    }else{
      tempData = this.sts.examsArray.filter((exam) =>  exam != 'All');
    }
    let sarr= [];
    for(let name of tempData){
      var exams = this.selecteduser ? (this.sts.isClinicGroup(name) ? this.sts.examsOfGroup(this.selecteduser.exams['All'], name) : this.selecteduser.exams[name]) : this.totalExams(name);
      var allexams = this.selecteduser ? this.selecteduser.exams['All'] : this.sts.statsForm.get(this.getDb('All')).value;
      if(name !='All' && exams && exams.length > 0){
        this.ChartLabels.push(name =='first' ? '1ST' : name);
        switch (this.chartType) {
          case 'pie':
            sarr.push(this.getPrecent(exams.length, allexams));
            //this.ChartDataSingle.push(Math.round(this.getPrecent(exams.length, allexams)));
            this.ChartOptions.scales.y.display = false;
            this.ChartOptions.scales.y.stacked = false;

            break;
          case 'doughnut':
            this.ChartOptions.scales.y.display = false;
            this.ChartOptions.scales.y.stacked = false;
            this.dougnutData.push(this.getPrecent(exams.length, allexams))
            // this.dougnutData.push(this.sts.statsForm.get(this.getDb(name)).value.length);
            break;
          case 'bar':
            this.ChartOptions.scales.y.display = true;
            this.ChartOptions.scales.y.stacked = true;
            // var prece =Math.round(this.sts.statsForm.get(this.getDb(name)).value.length)
            this.dougnutData.push(exams.length);
            break;
          default:
            break;
        }
      }
    }
    if(sarr)
      this.ChartDataSingle = sarr;
    if(this.chartType != 'pie'){
      this.barChartData[0].data = this.dougnutData;

    }
    if(this.chartType == 'bar')
      this.ChartOptions.plugins.title.display =false;
    this.data = [{data:this.data}];
    if(this.selecteduser && !this.selecteduser.exams.All){
      this.ChartLabels=[];
      this.ChartDataSingle=[];
      this.dougnutData=[];
      this.barChartData=[];
      this.data=[];
    }
    
    this.loaded = true;
  }

  totalExams(exam){
    if(this.sts.isClinicGroup(exam))
      return this.sts.examsOfGroup(this.sts.statsForm.get('All').value, exam);
    let control = this.sts.statsForm.get(this.getDb(exam));
    return control && control.value ? control.value : null;
  }

  userExams(user, exam){
    if(!user || !user.exams)
      return null;
    if(this.sts.isClinicGroup(exam))
      return this.sts.examsOfGroup(user.exams['All'], exam);
    return user.exams[this.getDb(exam)];
  }

  getPrecent(count=0,totalLength){
    if(!totalLength)
      return 0;
    return (count / totalLength.length * 100).toFixed(2)

  }

  getNotAssigned(array){
    if(! array){
      this.hmoNotAssign = []
      return 0;
    }
    var temp = array;
    this.hmoNotAssign =temp.filter((i) => i.HMO == null)
    return temp.filter((i) => i.HMO == null).length
  }

  chageChart(){

    switch (this.chartType) {
      case 'pie':
        this.ChartDataSingle = [];
        this.ChartType = 'pie';
        this.setData();
        break;
      case 'doughnut':
        this.ChartDataMulti=[];
        this.ChartType = 'doughnut';
        this.setData();
        break;
      case 'bar':
        this.ChartDataSingle = [];
        this.ChartType = 'bar';
        this.setData();
        break;
      default:
        break;
    }
  }
  chageData(){
    if(this.dataType =='exams'){
      this.ChartLabels = [];
      this.ChartDataSingle = [];
      this.ChartDataMulti = [];
      this.setData()
    }else{
      if(this.sts.usersStats.length > 0){
        this.ChartLabels = [];
        this.ChartDataSingle = [];
        this.ChartDataMulti = [];
        this.sts.usersStats.forEach((i) => {
            this.ChartLabels.push(i.user.UserName)
            var t = i.exams.All ? i.exams.All.length : 0;
            this.ChartDataSingle.push(t);
        })
        this.barChartData[0].data = this.ChartDataSingle;


      }
    }
    
  }

  selectUser(user){
    this.selecteduser = user
    this.dataType = 'exams';
    this.chageChart();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }

  //biopsy stats
  results: any = [];
  
   getReport(): void {
    this.pathologyService.getBiopsyStats(this.startdateb, this.enddateb, this.HMO).subscribe(data => {
      this.results = data;
    });
  }
   getParams(){
    if(this.results && this.results.length > 0){
      return Object.keys(this.results[0]);
    }
  }

  //export the biopsy stats to excel
  exportToExcel(): void {
    if (this.results) {
      // Prepare title row

      // Format date range for title using Angular DatePipe
      const formatDate = (d: any) => {
        if (!d) return '';
        // Try to use Angular DatePipe for all types
        return this.datePipe.transform(d, 'dd-MM-yyyy') || '';
      };
      let title = 'Biopsy/Polypectomy Stats';
      title += `  From ${formatDate(this.startdateb)} until ${formatDate(this.enddateb)}`;
      if (this.HMO && this.HMO.trim() !== '') {
        title += `  HMO: ${this.HMO}`;
      }

      // Prepare the rows as in the GUI table
      const total = this.results.Total || 0;
      const both = this.results.Both || 0;
      const biopsy = this.results.Biopsy || 0;
      const polypectomy = this.results.Polypectomy || 0;
      const allSamples = both + biopsy + polypectomy;
      const pct = (val) => total ? ((val / total) * 100).toFixed(2) + '%' : '0%';

      const rows = [
        ['Title', 'Count', 'Percentage'],
        ['Total Colonoscopy Exams', total, '100%'],
        ['Biopsy & Polypectomy', both, pct(both)],
        ['Biopsy Only', biopsy, pct(biopsy)],
        ['Polypectomy Only', polypectomy, pct(polypectomy)],
        ['All Samples', allSamples, total ? ((allSamples / total) * 100).toFixed(2) + '%' : '0%']
      ];

      // Create worksheet with title row at the top
      const worksheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([[title]]);
      XLSX.utils.sheet_add_aoa(worksheet, rows, {origin: 'A2'});
      // Merge the title row across all columns
      worksheet['!merges'] = worksheet['!merges'] || [];
      worksheet['!merges'].push({s: {r:0, c:0}, e: {r:0, c:2}});
      // Set the width of the first column to be wider
      worksheet['!cols'] = [
        { wch: 32 }, // First column width (Title)
        { wch: 12 }, // Count
        { wch: 14 }  // Percentage
      ];
      // Create workbook and export
      const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      XLSX.writeFile(workbook, 'biopsy_stats.xlsx');
    }
  }

}
